export const googleReviews = [
  {
    name: "Shivani aggarwal",
    date: "2026-07-14",
    text: "VERY Good Learning Tools for kids",
    rating: 5,
    avatarInitial: "S",
    avatarBg: "#8b5cf6"
  },
  {
    name: "Sanjay Aggarwal",
    date: "2026-07-14",
    text: "Very good learning program for AI,Coding 3d printing and Robotics.",
    rating: 5,
    avatarInitial: "S",
    avatarBg: "#3b82f6"
  },
  {
    name: "Sonia Sandhu",
    date: "2026-07-14",
    text: "Excellent",
    rating: 5,
    avatarInitial: "S",
    avatarBg: "#10b981"
  }
];
